import * as yup from 'yup';
import { validation } from '../registration-rules';
import { HeatSource } from '../../types/heatSource';
import { HeatSystem } from '../../types/heatSystems';
import { COOLANTS } from '../../types/coolantTypes';
import { InstallationTypeCode } from '../../types/installationType';

const RegistrationSystemYup = () => {
  const yupValidation = yup.object({
    heatSource: yup.array().of(yup.mixed<HeatSource['code']>().required()).min(1).required(),
    heatSystem: yup.array().of(yup.mixed<HeatSystem['code']>().required()).min(1).required(),
    coolant: yup
      .mixed()
      .oneOf(COOLANTS.map((c: any) => c.code))
      .required(),
    comment: yup.string().trim().max(validation.comment.max).optional(),
    installationType: yup.mixed().oneOf(Object.values(InstallationTypeCode)).required()
  });
  return yupValidation;
};
export default RegistrationSystemYup;
